import { render, staticRenderFns } from "./ReleaseOverviewTable.vue?vue&type=template&id=1df4dfa7&scoped=true&"
import script from "./ReleaseOverviewTable.vue?vue&type=script&lang=js&"
export * from "./ReleaseOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseOverviewTable.vue?vue&type=style&index=0&id=1df4dfa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4dfa7",
  null
  
)

export default component.exports